import { Route, Routes, Navigate } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { useIsMobile } from '@hooks/use-is-mobile';

import { Box } from 'components/Box';
import { Loading } from 'components/Loading';

import { ApplicationAccess } from './application-access';
import { ApplicationJourneys } from './application-journeys';
import { ApplicationApps } from './ApplicationApps';
import { ApplicationDetails } from './ApplicationDetails';
import { ApplicationFiles } from './ApplicationFiles';
import { ApplicationHeader } from './ApplicationHeader';
import { ApplicationMessages } from './ApplicationMessages';
import { ApplicationNotes } from './ApplicationNotes';
import { ApplicationReviews } from './ApplicationReviews';
import { ApplicationTabs } from './ApplicationTabs';

function Application({ application }) {
  const isMobile = useIsMobile();
  if (!application.loaded) {
    return (
      <Box grow>
        <Loading />
      </Box>
    );
  }

  return (
    <Box grow w="100%" style={{ overflowX: 'hidden' }}>
      <Box mb={isMobile ? '16' : '32'}>
        <ApplicationHeader application={application} />
      </Box>
      <ApplicationTabs application={application} border />

      <Routes>
        <Route path="details" element={<ApplicationDetails application={application} />} />
        <Route path="access" element={<ApplicationAccess application={application} />} />
        <Route path="notes" element={<ApplicationNotes application={application} />} />
        <Route path="files" element={<ApplicationFiles application={application} />} />
        <Route path="ratings" element={<ApplicationReviews application={application} />} />
        <Route path="messages" element={<ApplicationMessages application={application} />} />
        <Route path="apps" element={<ApplicationApps application={application} />} />
        <Route path="journeys" element={<ApplicationJourneys application={application} />} />
        <Route path="*" element={<Navigate to="details" />} />
      </Routes>
    </Box>
  );
}

export default observer(Application);
